export default __webpack_public_path__ + "static/media/arrow_forward_circle.f7b5a7a6.png";